import { render, staticRenderFns } from "./_items.vue?vue&type=template&id=3625a8df&scoped=true&"
import script from "./_items.vue?vue&type=script&lang=js&"
export * from "./_items.vue?vue&type=script&lang=js&"
import style0 from "./_items.vue?vue&type=style&index=0&id=3625a8df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3625a8df",
  null
  
)

export default component.exports